import { ROUTES } from '@/app/config/constants';

/**
 * The feature the supplier bid endpoints are guarded by (os_feature 'Supplier Bid', seeded for the Supplier role).
 * Retired from the RBAC screen; what an administrator ticks is BIDs (Request For Quotation), which the routes ask first.
 */
export const SUPPLIER_BID_FEATURE = 'Supplier Bid';

/** Where each Supplier Bid Quotation screen lives. */
export const supplierQuotationPaths = {
  /** The supplier's BIDs. */
  bids: ROUTES.SUPPLIER_BIDS,
  /** One BID's details. */
  bid: (rfqId: number) => `${ROUTES.SUPPLIER_BIDS}/${String(rfqId)}`,
  /** The supplier's quotation on one BID. */
  quotation: (rfqId: number) => `${ROUTES.SUPPLIER_BIDS}/${String(rfqId)}/quotation`,
};
